import { store } from 'store';
import {
  SET_LLAVES_DE_PREDIOS,
  SET_ORIENTACIONES_DE_PREDIOS,
  SET_TIPOS_DE_CLAVES_DE_PREDIOS,
  SET_TIPOS_DE_PREDIOS,
  SET_USOS_DE_PREDIO,
  SET_UNIDADES_DE_MEDIDA_PREDIOS,
  SET_REGIMENES_DE_PROPIEDAD,
} from 'store/reducers/catalogs';
import { message } from 'antd';
import API from 'utils/api';
import { formatReceived } from 'utils/formatValues';
import { onError } from 'utils/handlers';
import { pollEstadoJob } from 'api/utils/consultaTask';

const DEV = process.env.NODE_ENV === 'development';
export const baseURI = 'catastro/';

/**
 * GET Tipos de Llaves de Predios
 * @returns {Promise<Object[]>}
 */
export const getTiposDeLlavesDePredios = async () => {
  try {
    const response = await API.get(`${baseURI}clave-de-predios/`);
    store.dispatch({
      type: SET_TIPOS_DE_CLAVES_DE_PREDIOS,
      payload: response.data,
    });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Configuración de Clave
 * @param {Object>} params
 * @returns {Promise<Object[]>}
 */
export const getConfiguracionDeClave = async (params) => {
  try {
    const response = await API.get(`${baseURI}configuracion-de-la-clave/`, { params });
    store.dispatch({
      type: SET_LLAVES_DE_PREDIOS,
      payload: response.data,
    });
    await getTiposDeLlavesDePredios();
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Regimen de Propiedad
 * @returns {Promise<Object[]>}
 */
export const getRegimenesDePropiedad = async () => {
  try {
    const { regimenesDePropiedad } = store.getState().catalogs;
    if (regimenesDePropiedad.length) return regimenesDePropiedad;
    const response = await API.get(`${baseURI}regimenes-de-propiedades/`);
    store.dispatch({
      type: SET_REGIMENES_DE_PROPIEDAD,
      payload: response.data,
    });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Unidades de Medida de Predios
 * @returns {Promise<Object[]>}
 */
export const getUnidadesDeMedidaDePredios = async () => {
  try {
    const response = await API.get(`${baseURI}unidades-de-medida-de-predios/`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

export const getTipoDePredio = async (params) => {
  try {
    if (!params) {
      const { tiposDePredios } = store.getState().catalogs;
      if (tiposDePredios.length) return tiposDePredios;
    }
    const response = await API.get(`${baseURI}tipos-de-predios/`, { params });
    if (!params) store.dispatch({ type: SET_TIPOS_DE_PREDIOS, payload: response.data });
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};

export const getTipoDeDesarrollo = async () => {
  try {
    const response = await API.get(`${baseURI}tipos-de-desarrollo-de-predios/`);
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};

export const getTipoDeTenencia = async () => {
  try {
    const response = await API.get(`${baseURI}tipos-de-tenencias/`);
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};

/**
 * GET Unidades de Medida de Superficie de Predios
 * @returns {Promise<Object[]>}
 */
export const getUnidadesDeMedidaDeSuperficieDePredios = async () => {
  try {
    const { unidadesDeMedidaPredios } = store.getState().catalogs;
    if (unidadesDeMedidaPredios.length) return unidadesDeMedidaPredios;
    const response = await API.get(`${baseURI}unidades-de-medida-de-superficie-de-predios/`);
    store.dispatch({
      type: SET_UNIDADES_DE_MEDIDA_PREDIOS,
      payload: response.data,
    });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * @param {object} params
 * @returns {Promise<Object[]>}
 */
export const getPredioCaja = async (params = null) => {
  try {
    const response = await API.get('/catastro/predio-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

export const getUsosDePredio = async (params) => {
  try {
    if (!params) {
      const { usosDePredio } = store.getState().catalogs;
      if (usosDePredio.length) return usosDePredio;
    }
    const response = await API.get(`${baseURI}uso-de-predio/`, { params });
    if (!params) store.dispatch({ type: SET_USOS_DE_PREDIO, payload: response.data });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 *
 * @returns {Promise<Object[]>}
 */
export const getZonasHomogeneas = async (params) => {
  try {
    const response = await API.get(`${baseURI}zonas-homogeneas`, { params });
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};

/**
 *
 * @returns {Promise<Object[]>}
 */
export const getTiposDeTenencias = async () => {
  try {
    const response = await API.get(`${baseURI}tipos-de-tenencias`);
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};

/**
 *
 * @returns {Promise<Object[]>}
 */
export const getCorredoresDeValor = async () => {
  try {
    const response = await API.get(`${baseURI}corredores-de-valor`);
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};

/**
 *
 * @returns {Promise<Object[]>}
 */
export const getEstatusDelPredio = async () => {
  try {
    const response = await API.get(`${baseURI}estados-del-predio`);
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};

/**
 * Orientaciones de Predios
 * @returns {Promise<Object[]>}
 */
export const getOrientacionesDePredios = async () => {
  try {
    const orientacionesDePredios = store.getState().catalogs?.orientacionesDePredios;
    if (orientacionesDePredios.length) return orientacionesDePredios;
    const response = await API.get(`${baseURI}tipos-de-orientacion-predios`);
    store.dispatch({
      type: SET_ORIENTACIONES_DE_PREDIOS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};

/**
 * GET Tipos de aseos
 * @returns {Promise<Object[]>}
 */
export const getTiposDeAseos = async () => {
  try {
    const response = await API.get(`${baseURI}tipos-de-aseo/`);
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};
/**
 * GET Notarios de predio
 * @returns {Promise<Object[]>}
 */
export const getNotariosDePredio = async () => {
  try {
    const response = await API.get('catalogos/notarios-predios/');
    response.data.push({ id: 0, descripcion: 'Otro' });
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};

/**
 * GET Notarios de predio
 * @returns {Promise<Object[]>}
 */
export const getClavesZonificacion = async () => {
  try {
    const response = await API.get('catalogos/claves-de-zonificacion/');
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};

export const getClasesDeAseo = async () => {
  try {
    const response = await API.get('catastro/clases-de-aseo/');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getZonasDePredios = async () => {
  try {
    const response = await API.get('catastro/zonas-de-predios/');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getTiposDeDominio = async () => {
  try {
    const response = await API.get('catalogos/tipos-de-dominios/');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getMeritosDemeritos = async (params) => {
  try {
    const response = await API.get('catastro/meritos-demeritos/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getMeritosDemeritosValores = async (params) => {
  try {
    const response = await API.get('catastro/meritos-y-demeritos-valores/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getTiposDeConstruccion = async () => {
  try {
    const response = await API.get('catastro/tipos-de-construcciones/');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getCalidadesDeConstruccion = async () => {
  try {
    const response = await API.get('catastro/calidades-de-construcciones/');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getEstadosDeConstruccion = async () => {
  try {
    const response = await API.get('catastro/estados-de-construcciones/');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getTasasDePrediosUrbanos = async () => {
  try {
    const response = await API.get('catastro/tasas-de-predios-urbanos/');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getTasasDePrediosRurales = async () => {
  try {
    const response = await API.get('catastro/tasas-de-predios-rurales/');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getTasasDePredios = async (params) => {
  try {
    const response = await API.get('catastro/tasas-de-pedios/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getTasasDeTrasladoDePredios = async (params) => {
  try {
    const response = await API.get('recaudacion/tasa-traslado-de-dominio/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getClasificacionesDeLasConstrucciones = async (params) => {
  try {
    const response = await API.get('catastro/clasificaciones-de-construcciones/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getClasificacionesConstruccionesValores = async (params) => {
  try {
    const response = await API.get('catastro/clasificaciones-de-construcciones-valores/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getFactoresDeTraslado = async (params) => {
  try {
    const response = await API.get('catastro/factores-de-traslado/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getTiposDeValuacion = async (params) => {
  try {
    const response = await API.get('catastro/tipos-de-valuacion/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getTiposDeCuentasDePredios = async (params) => {
  try {
    const response = await API.get('catastro/tipos-de-cuentas-de-predio/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getSiglasTiposDePropietarios = async (params) => {
  try {
    const response = await API.get('catastro/siglas-tipos-de-propietarios/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getPeritos = async (params) => {
  try {
    const response = await API.get('catastro/peritos/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getTiposDePrediosUrbanos = async (params) => {
  try {
    const response = await API.get('catalogos/tipos-de-predio-urbano/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getEtapasDePredios = async (params) => {
  try {
    const response = await API.get('catalogos/etapas-de-predios/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getTiposDeAvaluo = async (params) => {
  try {
    const response = await API.get('catalogos/tipos-de-avaluo/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getPavimentosDePredios = async (params) => {
  try {
    const response = await API.get('catalogos/pavimentos-de-predios/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getSectoresCatastralesDePredios = async (params) => {
  try {
    const response = await API.get('catalogos/sectores-de-predios/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getRegionesCatastralesDePredios = async (params) => {
  try {
    const response = await API.get('catalogos/regiones-de-predios/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getParcelasDePredios = async (params) => {
  try {
    const response = await API.get('catalogos/parcelas-de-predios/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getSeccionesDePredios = async (params) => {
  try {
    const response = await API.get('catalogos/secciones-de-predios/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getEdificiosDePredios = async (params) => {
  try {
    const response = await API.get('catalogos/edificios-de-predios/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getUnidadesDePredios = async (params) => {
  try {
    const response = await API.get('catalogos/unidades-de-predios/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getManzanasDePredios = async (params) => {
  try {
    const response = await API.get('catalogos/manzanas-de-predios/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getTiposDeCondominiosDePredios = async (params) => {
  try {
    const response = await API.get('catalogos/tipos-de-condominio/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getValoresDeTerrenosYConstrucciones = async (params) => {
  try {
    const response = await API.get('catastro/valores-de-terreno-y-construccion/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getSiglasTiposPropietarios = async (params) => {
  try {
    const response = await API.get('catastro/siglas-tipos-de-propietarios/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const postConsultaCertificadoNoAdeudoAgua = async (params) => {
  const required = ['recaudadora', 'tipoPredio', 'cuenta'];
  const missing = required.filter((k) => !params[k]);
  if (missing.length) {
    return ['Información de predio incompleta, no es posible realizar consulta.'.concat(DEV ? ` (Falta: ${missing.join()})` : '')];
  }
  try {
    const response = await API.get('/catastro/cna-agua/consultar/', { params });
    return [null, response.data];
  } catch (err) {
    if (err.response.status === 404) {
      return ['No se encontró información disponible'];
    }
  }

  return ['No pudo realizarse consulta'];
};

const formatErroresImportacionMasivaPredios = (resultado) => {
  if (resultado?.message) return resultado.message;
  if (resultado?.errors) {
    return Object.entries(resultado.errors)
      .map(([campo, erroresDeCampo]) => {
        const detalle = Object.entries(erroresDeCampo)
          .map(([subCampo, mensajes]) => `${subCampo}: ${[].concat(mensajes).join(', ')}`)
          .join(' | ');
        return `${campo} -> ${detalle}`;
      })
      .join('\n');
  }
  return 'Ocurrió un error durante la importación masiva de predios.';
};

export const postImportacionMasivaPredios = async (data) => {
  if (!data?.length) return false;
  try {
    const response = await API.post('/catastro/importacion-masiva-predios/importar/', data);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

export const getEstadoImportacionMasivaPredios = async (jobId) => {
  const [data, error] = await pollEstadoJob(`/catastro/importacion-masiva-predios/${jobId}/estado/`);
  if (!data) {
    if (error?.timeout) {
      message.warn('La importación masiva está tardando más de lo esperado. Consulte más tarde el estado del proceso.', 8);
    }
    return false;
  }
  if (data.estado === 'error') {
    message.warn(formatErroresImportacionMasivaPredios(data.resultado), 8);
    return false;
  }
  return data.resultado;
};
